import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  getMortgage2011List,
  getMortgage2012List,
  getMortgage2015List,
} from '../../../common/data';
import HousingItemSection from './HousingItemSection';
import ItemTitleSection from '../../../components/ItemTitleSection';
import Typography from '../../../components/common/Typography';
import { formatNumber } from '../../../common/Util';

const Type2 = ({ onOpen }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('deductions/housingFunds');
  const { s10_1Data } = useSelector(state => state.housingFunds);

  const getTotal = list => {
    const allKeys = list.items.flatMap(item => item.key).filter(key => key !== 'total');

    const total = allKeys.reduce((acc, key) => acc + Number(s10_1Data[key] || 0), 0);
    return total;
  };

  // sections 배열에 total 값 포함
  const sections = [
    { ...getMortgage2011List(t), total: getTotal(getMortgage2011List(t)) },
    { ...getMortgage2012List(t), total: getTotal(getMortgage2012List(t)) },
    // { ...getMortgage2015List(t), total: getTotal(getMortgage2015List(t)) },
  ];

  const renderInputList = keys => {
    const baseInputs = [
      {
        label: t('typeItem.item1'),
        key: keys[0],
        disabled: true,
      },
      {
        label: t('typeItem.item2'),
        key: keys[1],
      },
    ];

    // total 키가 있는 경우에만 추가
    if (keys[2]) {
      baseInputs.push({
        label: t('typeItem.item3'),
        key: keys[2],
        color: 'secondary',
        variant: 'contained',
      });
    }

    return baseInputs;
  };

  return (
    <div className="displayFlexColumn" style={{ gap: '16px' }}>
      <ItemTitleSection
        title={t('detail.title2')}
        addButton
        handleAddButton={() => onOpen('type2', 'detail')}
      />

      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="displayFlexColumn" style={{ gap: '8px' }}>
          <Typography variant="body2Bold" color="Primary-500">
            {section.title}
          </Typography>

          <div className="displayFlexColumn" style={{ gap: '16px' }}>
            {section.items.map((item, itemIndex) => (
              <HousingItemSection
                key={`${section.year}-${itemIndex}`}
                title={item.label}
                dataList={s10_1Data}
                inputList={renderInputList(item.key)}
                total={formatNumber(section.total)}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Type2;
